// Angular
import {computed, Injectable, signal} from '@angular/core';

// Feature
import type {SimpleSendDraftResult} from '@app/features/simple-send/interfaces/simple-send-draft-result.interface';

@Injectable()
export class SimpleSendStoreService {
  readonly draft = signal<SimpleSendDraftResult | null>(null);
  readonly loading = signal(false);

  readonly draftId = computed(() => this.draft()?.id ?? null);

  setDraft(draft: SimpleSendDraftResult | null): void {
    this.draft.set(draft);
  }

  setLoading(value: boolean): void {
    this.loading.set(value);
  }

  reset(): void {
    this.draft.set(null);
    this.loading.set(false);
  }
}
